<template>
    <div>
        <ContentHeader path-set-type="append" :gameplan-nav="false" />
        <div class="content-wrapper">
            <el-row>
                <div class="card-top is-hover-shadow">
                    <div class="card-top-left">
                        <div class="top">2022/哈尔滨-国庆活动/Cross-Channel&CR&Club&KTV&bar</div>
                        <div class="bottom">
                            <div class="left">活动PR：PR002 - 哈尔滨 - 国庆活动PR</div>
                            <div class="right">哈尔滨</div>
                        </div>
                    </div>
                    <div class="card-top-right">
                        <div class="text-time">
                            活动执行时间：2022.01.16  至  2022.02.13
                        </div>
                    </div>
                </div>
                <!-- 售点信息 -->
                <div class="sale-place">
                    <div class="title">售点信息</div>
                    <div class="sale-place-card">
                        <div class="left">
                            <div class="item">
                                <div class="item-left">门店名称</div>
                                <div class="item-right">李哥小龙虾</div>
                            </div>
                            <div class="item">
                                <div class="item-left">渠道</div>
                                <div class="item-right">Cross-Channel</div>
                            </div>
                            <div class="item">
                                <div class="item-left">活动形式</div>
                                <div class="item-right">地标</div>
                            </div>
                            <div class="item">
                                <div class="item-left">BU</div>
                                <div class="item-right">74-吉林/辽宁|BU_JL</div>
                            </div>
                            <div class="item">
                                <div class="item-left">省份</div>
                                <div class="item-right">辽宁省</div>
                            </div>
                            <div class="item">
                                <div class="item-left">门店联系人</div>
                                <div class="item-right">李老板 - 15801010101</div>
                            </div>
                            <div class="item">
                                <div class="item-left">执行状态</div>
                                <div class="item-right">执行完成</div>
                            </div>
                        </div>
                        <div class="right">
                            <div class="item">
                                <div class="item-left">活动子品牌</div>
                                <div class="item-right">哈尔滨小麦王</div>
                            </div>
                            <div class="item">
                                <div class="item-left">门店编码</div>
                                <div class="item-right">POC001（7000325）</div>
                            </div>
                            <div class="item">
                                <div class="item-left">子渠道</div>
                                <div class="item-right"></div>
                            </div>
                            <div class="item">
                                <div class="item-left">活动级别</div>
                                <div class="item-right">基础</div>
                            </div>
                            <div class="item">
                                <div class="item-left">Region</div>
                                <div class="item-right">280-辽西南区|Liaoning_Southwest</div>
                            </div>
                            <div class="item">
                                <div class="item-left">城市</div>
                                <div class="item-right">沈阳</div>
                            </div>
                            <div class="item">
                                <div class="item-left">详细地址</div>
                                <div class="item-right">280-辽西南区|Liaoning_Southwest</div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 照片审批进度 -->
                <div class="photo-approval">
                    <div class="title">照片审批进度</div>
                    <div class="photo-approval-card">
                        <!-- <el-steps :active="active" finish-status="success">
                        <el-step title="照片已提交"></el-step>
                        <el-step title="销售已审批"></el-step>
                        <el-step title="Regin已审批"></el-step>
                        <el-step title="Bu审批中"></el-step>
                        <el-step title="HQ待审批"></el-step>
                        </el-steps> -->
                        <PhotoStep :stepFunction="stepFunction" :active="active" :stepList="stepList"></PhotoStep>
                    </div>

                </div>
                <!-- 场勘照片 -->
                <div class="photo-fieldSurvery">
                    <div class="title">
                        <div class="left">场勘照片</div>
                        <div class="right">审批中</div>
                    </div>
                    <div class="photo-fieldSurvery-card">
                        <div class="photo-item" v-for="(item) in 13" :key="item"></div>
                    </div>
                </div>
                <!-- 场地搭建照片 -->
                <div class="photo-fieldBuild">
                    <div class="title">
                        <div class="left">场地搭建照片</div>
                        <div class="right">审批中</div>
                    </div>
                    <div class="photo-fieldBuild-card">
                        <div class="card-item">
                            <div class="top">店外</div>
                            <div class="photo">
                                <div class="photo-item" v-for="(item) in 3" :key="item"></div>
                            </div>
                        </div>
                        <div class="card-item">
                            <div class="top">舞台</div>
                            <div class="photo">
                                <div class="photo-item" v-for="(item) in 3" :key="item"></div>
                            </div>
                        </div>
                        <div class="card-item">
                            <div class="top">台卡</div>
                            <div class="photo">
                                <div class="photo-item" v-for="(item) in 3" :key="item"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 执行照片 -->
                <div class="photo-implement">
                    <div class="title">
                        <div class="left">执行照片</div>
                        <div class="right">审批中</div>
                    </div>
                    <div class="photo-implement-card">
                        <div class="card-item">
                            <div class="top">互动</div>
                            <div class="photo">
                                <div class="photo-item" v-for="(item) in 3" :key="item"></div>
                            </div>
                        </div>
                        <div class="card-item">
                            <div class="top">舞台</div>
                            <div class="photo">
                                <div class="photo-item" v-for="(item) in 3" :key="item"></div>
                            </div>
                        </div>

                    </div>
                </div>
            </el-row>
        </div>        
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
    
    import ContentHeader from '@/components/content-header'
    import PhotoStep from './components/photo-step'
    
    export default {
      name: 'salePlace-detail',
      components: {
        ContentHeader,
        PhotoStep
      },
      data () {
        return {
            total:100,
            active: 6,
            stepList:[
                {name:'',index:1,title:'照片待提交',title2:'照片已提交'},
                {name:'',index:2,title:'销售待审批',title2:'销售已审批'},
                {name:'',index:3,title:'Regin已审批',title2:'Regin已审批'},
                {name:'',index:4,title:'Bu审批中',title2:'Bu已审批'},
                {name:'',index:5,title:'HQ待审批',title2:'HQ已审批'},
            ],
            queryParams: {
                page: 1,
                pageSize: 10,
                applyType: '',
                applyStatus: '',
                solutionStatus: '',
                acceptanceStatus: '',
                requirementStatus: '',
                executionStatus: '',
                isOwner: '',
                pledgePaid: '',
                applyClientLevel: '',
                queryType: '',
                queryRegionCode: '',
                queryBuCode: '',
                tradeStackWeek: '',
                tradeStackWeekStatus: '',
                waitClockIn: '',
                stackSpecs: '',
                applyNumber: '',
                vendorName: '',
                pocName: '',
                pocCode: '',
                execType: '',
                execTypeSub: '',
                isAll: '',
                keyword: '',
                orderCol: '',
                orderMethod: '',
                applyTypeTemp: '',
                applyStatusTemp: '',
                applySubStatusTemp: '',
                clientType: '',
                applyStatusList: '',
                waitSupplement: ''
            }, 
            searchForm: {
                storeName: '', // 门店名称
                selectBrand: '' , // 选择品牌
                selectChannel: '', // 选择渠道
                fieldSurveystatus: '', // 场勘状态
                buildStatus: '', // 搭建状态
                implementStatus: '', // 执行状态
            },
            options: [
            {
            value: '1',
            label: '黄金糕'
            }, {
            value: '2',
            label: '双皮奶'
            }, {
            value: '3',
            label: '蚵仔煎'
            }, {
            value: '4',
            label: '龙须面'
            }, {
            value: '5',
            label: '北京烤鸭'
            }
        ],
        }
      },
      computed: {
        ...mapGetters(['userInfo']),
      },
      watch: {
        $route (to, from) {
            console.log(to.params.activityType,'to');
            console.log(from.params.activityType,'from');
        }
      },
      created () {
        console.log(this.$route.params.activityType,'created-------activityType');
      },
      mounted () {      
      },
      methods: {
        handleCurrentChange (val) {
          this.queryParams.page = val
          console.log(val,'page');
        },
        submitForm (val) {
            console.log(this.searchForm,'search提交');
        this.$refs.searchForm.validate((valid) => {
          if (valid) {
            console.log(this.searchForm,'valid------search提交');

          } else {
            console.log('error submit!!');
            return false;
          }
        });
        },
        resetForm () {
            this.$refs.searchForm.resetFields();
            // this.$refs.searchForm.resetFields();
            console.log(this.searchForm,'重置后');
        },
        stepFunction(index){
        this.active = index
        // this.goStep(this.active)
        console.log(index,'父组件-index');
        console.log(this.active,'父组件-active');
        },
      }
    }
</script>
<style lang="scss" scoped>
    .is-hover-shadow:hover {
    box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.2);
    }
    ::v-deep.el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #fff;
        color:  #409EFF;
        border: 1px solid #409EFF 
    }
    ::v-deep.el-pagination.is-background .el-pager li:hover {
        color: #409EFF ;
    }
    // ::v-deep .el-step:hover {
    // cursor: pointer;
    // }

    // ::v-deep .el-step__head.is-process,
    // ::v-deep .el-step__head.is-success {
    // color: $base-red;
    // border-color: $base-red;
    // }
    // ::v-deep .el-step__title.is-process,
    // ::v-deep .el-step__title.is-success {
    // color: $base-red;
    // }   
    .content-wrapper {
      min-height: calc(100vh - 320px) !important;
      font-family: SourceHanSansSC-regular;
    
    //   .content-left,
      .content-right {
        height: 100%;
        box-sizing: border-box;
        a {
          text-decoration: none;
          color: #000;
        }
        .pagination {
            position: relative;
            bottom: 0;
        }
      }
      .content-left {
        padding-right: $content-middle;
      }
      .card-top {
        height: 53px;
        line-height: 20px;
        border-radius: 10px;
        padding: 20px;
        margin-bottom: 30px;
        font-size: 14px;
        text-align: center;
        background-color: #FFFFFF;
        color: #101010;
        font-family: Roboto;
        display: flex;
        justify-content: flex-start;
        .card-top-left {
            .top {
                height: 29px;
                line-height: 29px;
                color: #101010;
                font-size: 20px;
                text-align: left;
                font-family: SourceHanSansSC-medium;
                margin-bottom: 5px;
            }
            .bottom {
                display: flex;
                justify-content: flex-start;
                .left {
                    font-size: 16px;
                    margin-right: 11px;
                    height: 24px;
                    line-height: 24px;
                }
                .right {
                    width: 72px;
                    height: 24px;
                    line-height: 24px;
                    border-radius: 4px;
                    font-size: 14px;
                    background-color: #FFFFFF;
                    color: #539EFE;
                    border: 1px solid #539EFE;
                    text-align: center;
                    font-family: Microsoft Yahei;
                }
            }
        }
        .card-top-right {
            flex: 1;
            text-align: right;
            height: 20px;
            line-height: 20px;
            margin-top: 40px;
            color: #999999;
        }
      }
      .sale-place {
        .title {
            height: 50px;
            line-height: 50px;
            color: #101010;
            font-size: 20px;
            text-align: left;
            font-weight: bold;
            font-family: SourceHanSansSC-bold;
        }
        .sale-place-card {
            height: 222px;
            padding: 20px 0 20px 53px;
            background-color: #FFFFFF;
            border-radius: 10px;
            font-size: 14px;
            text-align: center;
            font-family: Roboto;
            display: flex;
            .left {
                width: 451px;
                .item {
                    display: flex;
                    height: 33px;
                    font-size: 14px;
                    text-align: left;
                    line-height: 33px;
                    .item-left {
                        width: 117px;
                        font-weight: 600;
                        font-family: Microsoft Yahei;
                    }
                    .item-right {
                        flex: 1;
                        font-family: Roboto;                       
                    }
                }
            }
            .right {
                flex: 1;
                height: 33px;
                font-size: 14px;
                text-align: left;
                line-height: 33px;
                .item {
                    display: flex;
                    height: 33px;
                    line-height: 33px;
                    .item-left {
                        width: 152px;
                        font-weight: 600;
                        font-family: Microsoft Yahei;
                    }
                    .item-right {
                        flex: 1;
                        font-family: Roboto;
                    }
                }
            }
        }
      }
      .photo-approval {
        margin-top: 20px;
        .title {
            height: 50px;
            line-height: 50px;
            color: #101010;
            font-size: 20px;
            text-align: left;
            font-weight: bold;
            font-family: SourceHanSansSC-bold;
        }
        .photo-approval-card {
            height: 31px;
            padding: 50px 127px ;
            background-color: #FFFFFF;
            font-size: 15px;
        }
      }
      .photo-fieldSurvery {
        margin-top: 30px;
        .title {
            height: 50px;
            line-height: 50px;
            color: #101010;
            font-size: 20px;
            text-align: left;
            font-weight: bold;
            font-family: SourceHanSansSC-bold;
            display: flex;
            .right {
                width: 66px;
                height: 21px;
                line-height:21px;
                margin-top: 15px;
                border-radius: 4px;
                background-color: #FFEAA6 ;
                color: #D19F00;
                font-size: 12px;
                text-align: center;
                font-family: Microsoft Yahei;
                margin-left: 5px;
            }
        }
        .photo-fieldSurvery-card {
            height: 222px;
            padding: 34px 0px 34px 39px ;
            background-color: #FFFFFF;
            display: flex;
            flex-wrap: wrap;
            .photo-item {
                width: 100px;
                height: 100px;
                margin-right: 20px;
                background-color: #acd121;
            }
        }

      }
      .photo-fieldBuild {
        margin-top: 30px;
        .title {
            height: 50px;
            line-height: 50px;
            color: #101010;
            font-size: 20px;
            text-align: left;
            font-weight: bold;
            font-family: SourceHanSansSC-bold;
            display: flex;
            .right {
                width: 66px;
                height: 21px;
                line-height:21px;
                margin-top: 15px;
                border-radius: 4px;
                background-color: #FFEAA6 ;
                color: #D19F00;
                font-size: 12px;
                text-align: center;
                font-family: Microsoft Yahei;
                margin-left: 5px;
            }
        }
        .photo-fieldBuild-card {
            height: 308px;
            padding: 10px 0 39px 39px ;
            background-color: #FFFFFF;
            font-size: 14px;
            color: #101010;
            display: flex;
            flex-wrap: wrap;
            .card-item {
                width: 579px;
                height: 148px;
                font-weight: bold;
                .top {
                    height: 48px;
                    line-height: 48px;
                    text-align: left;
                    font-family: Microsoft Yahei;
                }
                .photo {
                    display: flex;
                    flex-wrap: wrap;
                    .photo-item {
                        width: 100px;
                        height: 100px;
                        margin-right: 20px;
                        background-color: #D19F00;
                    }
                }
            }
        }

      }
      .photo-implement {
        margin-top: 30px;
        .title {
            height: 50px;
            line-height: 50px;
            color: #101010;
            font-size: 20px;
            text-align: left;
            font-weight: bold;
            font-family: SourceHanSansSC-bold;
            display: flex;
            .right {
                width: 66px;
                height: 21px;
                line-height:21px;
                margin-top: 15px;
                border-radius: 4px;
                background-color: #FFEAA6 ;
                color: #D19F00;
                font-size: 12px;
                text-align: center;
                font-family: Microsoft Yahei;
                margin-left: 5px;
            }
        }
        .photo-implement-card {
            height: 143px;
            padding: 10px 0 39px 39px ;
            background-color: #FFFFFF;
            font-size: 14px;
            color: #101010;
            display: flex;
            flex-wrap: wrap;

            .card-item {
                width: 579px;
                height: 148px;
                font-weight: bold;
                .top {
                    height: 48px;
                    line-height: 48px;
                    text-align: left;
                    font-family: Microsoft Yahei;
                }
                .photo {
                    display: flex;
                    flex-wrap: wrap;
                    .photo-item {
                        width: 100px;
                        height: 100px;
                        margin-right: 20px;
                        background-color: #D19F00;
                    }
                }
            }
        }

      }
    }
    // .el-step__icon.is-text {
    // border: 2px solid;
    // border-color: inherit;
    // }
    // .el-step__icon-inner {
    //     -webkit-user-select: none;
    //     -moz-user-select: none;
    //     -ms-user-select: none;
    //     user-select: none;
    //     text-align: center;
    //     font-weight: 700;
    //     line-height: 1;
    //     color: inherit;
    // }
    // .el-step.is-horizontal .el-step__line {
    // height: 2px;
    // top: 11px;
    // left: 0;
    // right: 0;
    // }
    // .el-step__title {
    // font-size: 16px;
    // line-height: 38px;
    // position: relative;
    // border: 1px solid red;
    // }
    
</style>